var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyesButtonIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.5C4.21846 15.5 0.361648 8.59326 0.201278 8.2993L0.0380859 8L0.201278 7.7007C0.361648 7.40674 4.21846 0.5 12 0.5C19.7815 0.5 23.6383 7.40674 23.7987 7.7007L23.9619 8L23.7987 8.2993C23.6383 8.59326 19.7815 15.5 12 15.5ZM1.47958 7.99931C2.29425 9.28174 5.84894 14.25 12 14.25C18.167 14.25 21.7079 9.28525 22.5204 8.00076C21.7051 6.71742 18.1506 1.75 12 1.75C5.83299 1.75 2.29204 6.71483 1.47958 7.99931ZM12 12.375C9.58757 12.375 7.62498 10.4124 7.62498 8C7.62498 5.58759 9.58757 3.625 12 3.625C14.4124 3.625 16.375 5.58759 16.375 8C16.375 10.4124 14.4124 12.375 12 12.375ZM12 4.875C10.2769 4.875 8.87498 6.2769 8.87498 8C8.87498 9.7231 10.2769 11.125 12 11.125C13.7231 11.125 15.125 9.7231 15.125 8C15.125 6.2769 13.7231 4.875 12 4.875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyesButtonIcon);
export default __webpack_public_path__ + "static/media/eyesButtonIcon.65bf1afe1a04a9626b061fa35e939983.svg";
export { ForwardRef as ReactComponent };